import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import i18n from "@/i18n";
import { localize } from '@vee-validate/i18n'
import en from '@vee-validate/i18n/dist/locale/en.json';
import de from '@vee-validate/i18n/dist/locale/de.json';
import fr from '@vee-validate/i18n/dist/locale/fr.json';
import it from '@vee-validate/i18n/dist/locale/it.json';
import rs from '@vee-validate/i18n/dist/locale/sr_Latin.json';
import es from '@vee-validate/i18n/dist/locale/es.json'
import {configure} from "vee-validate";
import axios from "axios";
import bootstrap from "@/bootstrap";
import { clickOutside } from "@/directives";
import * as Sentry from "@sentry/vue";
import { clearExpiredAnimatedUsers } from "@/service/animations";
import { getQueryParamValue } from "@/utilities/general";
import { availableLanguages } from "@/service/languages";
import "@/assets/styles/_shared.scss";
import { isSugarDaddyTheme } from "@/service/general";

i18n.global.locale = availableLanguages().includes(getQueryParamValue('lang')) ? getQueryParamValue('lang') : null ?? availableLanguages()[0]
store.commit('authenticate/setLang', i18n.global.locale)

configure({
    generateMessage: localize({
        de: {
            ...de,
            names: {
                username: 'Benutzername',
                email: 'E-Mail-Adresse',
                password: 'Passwort',
                location: 'Standort'
            }
        },
        it: {
            ...it,
            names: {
                username: 'nome utente',
                email: 'indirizzo email',
                password: 'password',
                location: 'località'
            }
        },
        fr: {
            ...fr,
            names: {
                username: "nom d'utilisateur",
                email: 'adresse e-mail',
                password: 'mot de passe',
                location: 'localisation'
            }
        },
        en: {
            ...en,
            names: {
                username: 'username',
                email: 'email address',
                password: 'password',
                location: 'location'
            }
        },
        rs: {
            ...rs,
            names: {
                username: 'korisničko ime',
                email: 'imejl adresa',
                password: 'lozinka',
                location: 'lokacija'
            }
        },
        es: {
            ...es,
            names: {
                username: 'nombre de usuario',
                email: 'correo electrónico',
                password: 'contraseña',
                location: 'ubicación'
            }
        }
    })
})

axios.defaults.baseURL = process.env.VUE_APP_API_URL
// axios.defaults.withCredentials = true
axios.defaults.withXSRFToken = true;

bootstrap().then(() => {

    const app = createApp(App)

    if(process.env.VUE_APP_ENVIRONMENT !== 'local' && isSugarDaddyTheme()) {

        Sentry.init({
            app,
            environment: process.env.VUE_APP_ENVIRONMENT,
            release: `${process.env.VUE_APP_VERSION}`,
            dsn: process.env.VUE_APP_SENTRY_DSN,
            replaysSessionSampleRate: 0,
            replaysOnErrorSampleRate: 1.0,
            integrations: [
                new Sentry.Replay({
                    maskAllText: false,
                    maskAllInputs: false
                })
            ],
            debug: process.env.VUE_APP_ENVIRONMENT  !==  'production',
            // Vue specific
            logErrors: process.env.VUE_APP_ENVIRONMENT !== 'local',
            attachProps: true,
            attachStacktrace: true,
        })

    }

    app.use(store).use(router).use(i18n).directive('click-outside', clickOutside).mount('#app')

    clearExpiredAnimatedUsers()

})


